import React from 'react'


function Hero() {
    return (
        <div className='container'>
            <div className='text-center p-5 my-5'>
                <h2>Zerodha Products</h2>
                <p className='fs-3'>Sleek, modern, and intuitive trading platforms</p>
                 <a href="https://zerodha-clone-kite.onrender.com" target='_blank' className='btn btn-primary'>Try Kite Demo</a><br/><br/>
                <p>Check out our <a href='' style={{ textDecoration: 'none' }}>investment offerings → </a></p>
            </div>
        </div>
    );
}

export default Hero;